export default __webpack_public_path__ + "static/media/bus_alert_icon.195a489b.svg";